import {
  QUANLYTHENAP_COUNT_ASSIGN_SUCCESS,
  QUANLYTHENAP_HISTORY_LIST_SUCCESS,
  QUANLYTHENAP_IMPORT_SUCCESS,
  QUANLYTHENAP_LIST_SUCCESS,
  QUANLYTHENAP_NEW_CARE_SUCCESS,
  QUANLYTHENAP_ONE_SUCCESS,
  QUANLYTHENAP_UPDATE_FILTER,
  QUANLYTHENAPCOMLIST_LIST_SUCCESS,
} from 'src/actions/quanlythenap.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  quanlythenapcomlist_items: [],
  quanlythenapcomlist_total: 0,
  temp: [],
  selected: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const quanlythenapReducer = (state = initState, action) => {
  switch (action.type) {
    case QUANLYTHENAP_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case QUANLYTHENAPCOMLIST_LIST_SUCCESS: {
      console.log({
        quanlythenapcomlist_items: action.data.items,
        quanlythenapcomlist_total: action.data.total,
      })
      return {
        ...state,
        quanlythenapcomlist_items: action.data.items,
        quanlythenapcomlist_total: action.data.total,
      }
    }
    case QUANLYTHENAP_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tong_sai_menh_gia: action.data.tong_sai_menh_gia,
        tong_dung_menh_gia: action.data.tong_dung_menh_gia,
        tong_loi_huy: action.data.tong_loi_huy,
        tong_doi_soat: action.data.tong_doi_soat,
        tong_chua_nap: action.data.tong_chua_nap,
        tong_nap: action.data.tong_nap,
        tong_the: action.data.tong_the,
      }
    }
    case QUANLYTHENAP_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case QUANLYTHENAP_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case QUANLYTHENAP_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case QUANLYTHENAP_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case QUANLYTHENAP_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default quanlythenapReducer